import { Utilities } from '../Utility/Utilities';
import * as toastr from "toastr";
import * as events from '../Bus/Bus';
import { FeatureType, ICAMSKey } from '../Models/UtilityModels';

export class Audit {

    // ----------------------------------------------------------- //
    // GLOBAL VARS

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this; 
    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    public openAuditIntoElement = (el: any, data: ICAMSKey): void => {
        const self = this;

        // Bind events when the popover is shown
        el.off("show.bs.popover");
        el.on("show.bs.popover", function () {
            //$($(this).data("bs.popover").getTipElement()).css("max-width", "400px");
        });

        el.off("shown.bs.popover");
        el.on("shown.bs.popover", function () {
            $(".popover-close-btn").click(function () {
                el.popover("hide");
            });

            let popoverEl = $('[data-popper-reference-hidden]');
            let popoverBody = popoverEl.find(".popover-body");
            if (popoverBody.length == 0) {
                var tmpEl = document.createElement("div");
                $(tmpEl).addClass("popover-body");
                popoverEl.append(tmpEl);
                popoverBody = popoverEl.find(".popover-body");
            }
            popoverEl.find(".popover-header").html(popoverTitleDiv);

            //Utilities.BlockUI($(".popover"));
            popoverBody.load('/Audit/AuditList', { data: data } , function (response, status, xhr) {
                //Utilities.UnBlockUI($(".popover"));
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }

                // Bind rows
                $('[data-activityid]').on("click", function () {
                    el.popover("hide");
                    
                });

            });

        });

        // Create and show the popover
        let popoverTitleDiv =
            "<div class='d-flex justify-content-between'>" +
            "<div class='p'>Audit Info</div>" +
            "</div>";
        el.attr('data-original-title', popoverTitleDiv);

        el.popover({
            html: true,
            toggle: 'popover',
            trigger: 'click',
            title: popoverTitleDiv,
            content: "Loading..."
        });
        el.popover('toggle');
    }


    // ----------------------------------------------------------- //
    // MISC
    
}




